export interface AutomationAttributeProps {
  qaId?: string;
  testId?: string;
  componentName?: string;
}

export const buildAutomationAttributes = ({ qaId, testId, componentName }: AutomationAttributeProps = {}) => {
  return {
    ...(componentName ? { "data-component": componentName } : {}),
    ...(qaId ? { "data-qa": qaId } : {}),
    ...(testId ? { "data-testid": testId } : {}),
  };
};
